import * as React from 'react';
export const IcOrders = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.54 3.88l-2.19-.82a1.05 1.05 0 00-.7 0L4 5.93l2.66 1 7.88-3.05zm-6.91 9.34a1 1 0 01-2 0V8.68L3 7.69V17a1 1 0 00.65.94L11 20.69v-10L7.63 9.43v3.79zm9.73-8.28L9.48 8l2.52.93 8-3-2.64-.99zM13 10.69v10l7.35-2.75A1 1 0 0021 17V7.69l-8 3z'
      fill='currentColor'
    />
  </svg>
);
